import { apiRequest } from "./apiClient";

export async function fetchPlatformSettings() {
  const body = await apiRequest("/api/v1/admin/platform-settings");
  return body.data;
}

export async function updatePlatformSettings(payload) {
  const body = await apiRequest("/api/v1/admin/platform-settings", {
    method: "PUT",
    body: JSON.stringify(payload),
  });
  return body.data;
}
